import routes from '../../../constants/routes';

export default function handleEditReportNav(history: { push: (path: string) => void }, reportId: number | null): void {
  history.push(`${routes.CUSTOM_REPORTS}?id=${encodeURIComponent(String(reportId))}&edit=true`);
}

export function checkTitleExists(
  title: string,
  allReports: { id: number; title: string }[],
  currentReportId: number | null
): boolean {
  const titleWithoutLastSpace = title.trimEnd();
  return allReports.some(
    (report) => report.title.toLowerCase() === titleWithoutLastSpace.toLowerCase() && report.id !== currentReportId
  );
}

export const datasetNameMap: Record<string, string> = {
  '0': 'checkSummary',
  '1': 'itemSales',
  '2': 'itemDiscounts',
  '3': 'laborShifts',
};
